import React, { useContext } from "react";
import ReactDOM from "react-dom";

import "./Modal.scss";
import UIContext from "../../components/Store/ui-context";

interface ModalProps {
  children: JSX.Element;
}

const Backdrop = () => {
  const uiContext = useContext(UIContext);
  const hideModal = () => {
    uiContext.setShowModal(false);
  };
  return <div className="backdrop" onClick={hideModal} />;
};

const ModalOverlay: React.FC<ModalProps> = (props) => {
  return <div className="modal">{props.children}</div>;
};

const Modal: React.FC<ModalProps> = (props) => {
  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop />,
        document.getElementById("backdrop") as HTMLElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        document.getElementById("overlay") as HTMLElement
      )}
    </>
  );
};

export default Modal;
